<div class="wrapper">
    <owl-carousel-o [options]="customOptions">
        <ng-template class="slide" carouselSlide id="1">
            <div class="slide-item">

                <img class="ms-layer ms-hover-active" src="../../../assets/images/sl-line.png" alt=""
                    style="width: 100%; height: 8px; bottom: 0px; left: 0; position: absolute; z-index: 1;">
                <img class="ms-layer  msp-cn-24-166 ms-hover-active" src="../../../assets/images/Untitled-12 (1).png"
                    alt="" style="position: absolute; width: 100%; height: 100%; top: 0;
                    left: 0;  opacity: 0.5;">
                <img class="ms-layer ms-hover-active cover-img" src="../../../assets/images/w2b.png" alt="" style="max-width: 55%; bottom: 253px;
                    position: absolute;" />

                <div class="btn-container" style="display: flex; justify-content: space-between; width: 50%; position: absolute; bottom: 158px;
                max-width: 1366px">

                    <!-- <div class="ms-btn-container"><a href="https://ehraz.aban.net/" target="_self"
                            class="ms-layer  msp-cn-24-169 msp-cn-24-165 ms-btn ms-btn-round ms-btn-n msp-preset-btn-204 ms-hover-active"
                            style="position: relative; ">
                            ثبت‌نام سجام</a></div> -->

<!-- 
                    <div class="ms-btn-container">
                        <a target="_blank" href="https://aban.ebgo.ir/Login" target="_blank"
                            class="ms-layer  msp-cn-24-165 ms-btn ms-btn-round ms-btn-n msp-preset-btn-203 ms-hover-active"
                            style="position: relative; ">
                            دریافت کد بورس کالا</a>
                    </div> -->
                    
                    <div class="ms-btn-container">
                        <a target="_blank" [routerLink]="['/customers/services/how-to-register']"
                        class="ms-layer  msp-cn-24-165 ms-btn ms-btn-round ms-btn-n msp-preset-btn-203 ms-hover-active"
                        style="position: relative; ">
                        افتتاح حساب با آبان</a>
                    </div>
                    
                    <div class="ms-btn-container"><a href="https://aban.ebgo.ir/Login" target="_blank"
                        class="ms-layer  msp-cn-24-165 ms-btn ms-btn-round ms-btn-n msp-preset-btn-204 ms-hover-active"
                        style="position: relative;   ">
                        دریافت کد بورس کالا</a></div>

                    <!-- <div class="ms-btn-container"><a href="https://abanse.etadbir.com/login.html" target="_blank"
                            class="ms-layer  msp-cn-24-163 ms-btn ms-btn-round ms-btn-n msp-preset-btn-204 ms-hover-active"
                            style="position: relative;   ">
                            فروش سهام عدالت</a></div> -->


                </div>
            </div>
        </ng-template>

        <!-- <ng-container *ngFor="let slide of apiData">
        </ng-container> -->

    </owl-carousel-o>
</div>